var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"z-verification",attrs:{"type":"button"},on:{"click":_vm.onGetPin}},[_vm._v("\n  "+_vm._s(_vm.time > 0 ? (_vm.time + "s后重新获取") : _vm.title)+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }